import { render, staticRenderFns } from "./FichaPPAfiliacion.html?vue&type=template&id=5716a390&external"
import script from "./FichaPPAfiliacion.vue?vue&type=script&lang=js"
export * from "./FichaPPAfiliacion.vue?vue&type=script&lang=js"
import style0 from "./FichaPPAfiliacion.vue?vue&type=style&index=0&id=5716a390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports